import React from 'react';

const Icon = ({ width = '47', height = '48', fill = 'white', ...other }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 47 48" fill="none" {...other}>
            <g clipPath="url(#a)" stroke="black" strokeWidth="2.112" strokeLinecap="round" strokeLinejoin="round">
                <path d="M8.668 30.923v7.355c0 .38.307.686.686.686H38.96c.38 0 .686-.307.686-.686v-2.309a.686.686 0 0 0-.686-.686H15.058a.686.686 0 0 1-.686-.686v-4.292m-2.126 8.658v1.872m23.934-1.872v1.872" />

                <path d="M31.324 16.375c2.674 3.58 2.559 8.663-.528 12.13-3.323 3.735-8.905 4.265-12.854 1.364" />

                <path
                    clipRule="evenodd"
                    d="M11.958 23.57a11.11 11.11 0 0 1 3.19-10.066c4.413-4.272 11.453-4.158 15.724.255l-3.704 3.707c-2.221-1.952-5.579-1.878-7.74.214-2.274 2.202-2.667 5.72-.466 7.994l-6.573 6.575a1.658 1.658 0 0 1-2.333.012l-2.218-2.178a1.658 1.658 0 0 1-.015-2.351l4.135-4.162Z"
                />

                <path d="m29.376 12.463 3.84-3.84a.686.686 0 0 0 0-.971l-1.308-1.308a.685.685 0 0 0-.97 0l-4.58 4.58m-2.442 9.479a1.844 1.844 0 1 1-2.023 2.023l-.01-.189.01-.188c.095-.93.88-1.655 1.834-1.655l.189.01Z" />
            </g>
            <defs>
                <clipPath id="a">
                    <path fill={fill} d="M0 .27h46.988v46.988H0z" />
                </clipPath>
            </defs>
        </svg>
    );
};
export default React.memo(Icon);
